import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, FieldTypes, useResponsive } from '@common-fe/common-fe';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { AUTH_ERROR_KEY } from '@/common/constants';
import { centeredFieldStyles } from '@/modules/user/components/SignUp/signUp.constants';

export default () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();

  const fields = useMemo<Field[]>(
    () => [
      {
        name: 'password',
        type: FieldTypes.Password,
        label: 'Password',
        isLarge: true,
        placeholder: 'Password',
        showRequireIcon: true,
        passwordHelper: true,
        isErrorLarge: true,
        validator: VALIDATORS.PASSWORD,
        ...(isMobile ? {} : centeredFieldStyles),
      },
      {
        name: 'confirmPassword',
        type: FieldTypes.Password,
        label: 'Confirm password',
        isLarge: true,
        placeholder: 'Confirm password',
        showRequireIcon: true,
        validator: yup
          .string()
          .required(t(AUTH_ERROR_KEY.PASSWORD_IS_REQUIRED))
          .oneOf([yup.ref('password')], t(AUTH_ERROR_KEY.PASSWORD_DO_NOT_MATCH)),
        ...(isMobile ? {} : centeredFieldStyles),
      },
    ],
    [isMobile, t]
  );
  return fields;
};
